import axios from 'axios'
import UserClient from '@/services/resource_client/user'
import ParkClient from '@/services/resource_client/park'

const STORAGE_KEY_API_TOKEN = 'api_token'
const STORAGE_KEY_USER_ROLE = 'user_role'
const STORAGE_KEY_USER_ID = 'user_id'
const STORAGE_KEY_PARK_ID = 'park_id'
const STORAGE_KEY_PARK_CURRENT_STAGE = 'current_stage'
const USER_ROLE_RESEARCHER = 'ROLE_RESEARCHER'
const USER_ROLE_ADMIN = 'ROLE_ADMIN'
const USER_ROLE_PARK = 'ROLE_PARK'
const USER_ROLE_PARTNER = 'ROLE_PARTNER'

export default {
  login (email, password) {
    return new Promise((resolve, reject) => {
      this.getApiToken(email, password)
        .then(() => {
          this.getCurrentUser()
            .then(currentUser => {
              if (this.userHasParkRole()) {
                this.logout()
                reject(new Error('ROLE_PARK'))
                return
              }
              resolve(currentUser)
            })
            .catch(reject)
        })
        .catch(reject)
    })
  },
  getApiToken (email, password) {
    return axios.post(process.env.API_URL + 'login_check', '_email=' + email + '&_password=' + password)
      .then(r => {
        localStorage.setItem(STORAGE_KEY_API_TOKEN, r.data.token)
        return r
      })
      .catch(e => { throw e })
  },
  getCurrentUser () {
    return UserClient.getCurrentUser()
      .then(r => {
        localStorage.setItem(STORAGE_KEY_USER_ROLE, r.data.roles[0])
        localStorage.setItem(STORAGE_KEY_USER_ID, r.data.id)
        return r
      })
      .catch(e => { throw e })
  },
  logout () {
    this.clearStorage()
  },
  clearStorage () {
    localStorage.removeItem(STORAGE_KEY_API_TOKEN)
    localStorage.removeItem(STORAGE_KEY_USER_ROLE)
    localStorage.removeItem(STORAGE_KEY_USER_ID)
    localStorage.removeItem(STORAGE_KEY_PARK_ID)
    localStorage.removeItem(STORAGE_KEY_PARK_CURRENT_STAGE)
  },
  isAuthenticated () {
    return typeof localStorage.getItem(STORAGE_KEY_API_TOKEN) !== 'undefined' &&
      localStorage.getItem(STORAGE_KEY_API_TOKEN) !== null
  },
  getUserRole () {
    return localStorage.getItem(STORAGE_KEY_USER_ROLE)
  },
  userHasResearcherRole () {
    return this.getUserRole() === USER_ROLE_RESEARCHER
  },
  userHasAdminRole () {
    return this.getUserRole() === USER_ROLE_ADMIN
  },
  userHasParkRole () {
    return this.getUserRole() === USER_ROLE_PARK
  },
  userHasPartnerRole () {
    return this.getUserRole() === USER_ROLE_PARTNER
  },
  getUserId () {
    return localStorage.getItem(STORAGE_KEY_USER_ID)
  },
  getParkData () {
    return ParkClient.getParkByUserId(this.getUserId())
      .then(r => {
        localStorage.setItem(STORAGE_KEY_PARK_ID, r.data[0].id)
        localStorage.setItem(STORAGE_KEY_PARK_CURRENT_STAGE, r.data[0].currentStage)
        return r
      })
      .catch(e => { throw e })
  },
  getParkId () {
    return localStorage.getItem(STORAGE_KEY_PARK_ID)
  },
  getParkCurrentStage () {
    return localStorage.getItem(STORAGE_KEY_PARK_CURRENT_STAGE)
  }
}



// WEBPACK FOOTER //
// ./src/services/authentication.js